class SolyraCollectionsGrid extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('[data-collections-card]'));
    this.dots = Array.from(this.querySelectorAll('[data-collections-dot]'));
    this.previousButton = this.querySelector('[data-collections-previous]');
    this.nextButton = this.querySelector('[data-collections-next]');
    this.pageSize = Number.parseInt(this.dataset.pageSize, 10) || this.cards.length;
    this.pageCount = Math.ceil(this.cards.length / this.pageSize);
    this.currentIndex = 0;
    this.isAnimating = false;

    this.update({ animate: false });
    if (this.pageCount <= 1) return;

    this.previousButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
    this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goTo(index));
    });
  }

  goTo(index) {
    if (this.isAnimating) return;

    const nextIndex = (index + this.pageCount) % this.pageCount;
    if (nextIndex === this.currentIndex) return;

    this.currentIndex = nextIndex;
    this.update({ animate: true });
  }

  motionDuration(name, fallback) {
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    if (!value) return fallback;
    const parsed = Number.parseFloat(value);
    if (!Number.isFinite(parsed)) return fallback;
    return value.endsWith('ms') ? parsed : parsed * 1000;
  }

  update({ animate = false } = {}) {
    const firstVisibleIndex = this.currentIndex * this.pageSize;
    const lastVisibleIndex = firstVisibleIndex + this.pageSize;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (animate && !prefersReducedMotion) {
      this.isAnimating = true;
      this.classList.add('is-page-changing');

      window.setTimeout(() => {
        this.showPage(firstVisibleIndex, lastVisibleIndex);
        this.keepSectionInView();
        this.classList.remove('is-page-changing');
        this.classList.add('is-page-entering');

        window.setTimeout(() => {
          this.classList.remove('is-page-entering');
          this.isAnimating = false;
        }, this.motionDuration('--motion-duration-base', 180));
      }, this.motionDuration('--motion-duration-fast', 120));
    } else {
      this.showPage(firstVisibleIndex, lastVisibleIndex);
      if (animate) {
        this.keepSectionInView();
      }
    }

    this.dots.forEach((dot, index) => {
      const isCurrent = index === this.currentIndex;
      dot.setAttribute('aria-current', isCurrent ? 'true' : 'false');
    });
  }

  showPage(firstVisibleIndex, lastVisibleIndex) {
    const visibleCards = [];

    this.cards.forEach((card, index) => {
      const isHidden = index < firstVisibleIndex || index >= lastVisibleIndex;

      card.hidden = isHidden;
      card.classList.remove('collection-card--wide');
      card.removeAttribute('data-visible-index');

      if (!isHidden) {
        visibleCards.push(card);
      }
    });

    visibleCards.forEach((card, index) => {
      card.dataset.visibleIndex = String(index + 1);
    });

    if (visibleCards.length % 2 === 1) {
      visibleCards[visibleCards.length - 1]?.classList.add('collection-card--wide');
    }
  }

  keepSectionInView() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const section = this.closest('.collections-page') || this;
    const top = section.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: Math.max(0, top - 8),
      behavior: 'auto',
    });
  }
}

if (!customElements.get('solyra-collections-grid')) {
  customElements.define('solyra-collections-grid', SolyraCollectionsGrid);
}
